import { service } from '../../../../helpers/http' 

export const ActionGetSmartshare = ({ dispatch }, payload) => { 
    return service({
        module: 'domainSmartshare',
        action: 'getSmartshare',
        payload: payload
    })
}

export const ActionPostSmartshare = ({ dispatch }, payload) => {

    return service({
        module: 'domainSmartshare',
        action: 'postSmartshare',
        payload: payload
    })
    
}

export const ActionPutSmartshare = ({ dispatch }, payload) => {

    return service({
        module: 'domainSmartshare',
        action: 'putSmartshare',
        payload: payload
    })
    
}

export const ActionDeleteSmartshare = ({ dispatch }, payload) => {

    return service({
        module: 'domainSmartshare',
        action: 'deleteSmartshare',
        payload: payload
    })
    
}
